<template>
    <el-card v-loading="loading">
        <template slot="header">
            关于我们
        </template>
        <el-form :model="About"
                 :rules="rules"
                 ref="ruleForm"
                 label-position="right"
                 label-width="130px">
            <el-form-item label="标题" prop="title">
                <el-input v-model="About.title"></el-input>
            </el-form-item>
            <el-form-item label="开发协作" prop="development">
                <el-input v-model="About.development"></el-input>
            </el-form-item>
            <el-form-item label="联合推广" prop="joint">
                <el-input v-model="About.joint"></el-input>
            </el-form-item>
            <el-form-item label="版权所有" prop="copyright">
                <el-input v-model="About.copyright"></el-input>
            </el-form-item>
            <el-form-item label="内容" prop="content">
                <textarea id="content"></textarea>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="update('ruleForm')">保存</el-button>
                <el-button type="success" @click="back">返回</el-button>
            </el-form-item>
        </el-form>
    </el-card>
</template>

<script>
    import {mapState} from 'vuex'
    import '@/static/test'
    import Upload from "element-ui/packages/upload/src/upload";
    import ImgUpload from "../img/ImgUpload";
    import config from "@/lib/http/config"

    export default {
        name: "About",
        props: {
            id: {
                required: true
            },
        },
        components: {ImgUpload, Upload},
        data() {
            return {
                about:{},
            };
        },
        created() {
            this.$store.dispatch('about/show', {id: this.id});
        },
        computed: {
            ...mapState({
                About: state => state.about.About,
                content: state => state.about.content,
                rules: state => state.about.rules,
                loading: state => state.about.loading
            }),
        },
        mounted (){
            CKEDITOR.replace('content', {
                filebrowserImageUploadUrl: config.baseURL + '/api/ck/upload',
                language: 'zh-cn',
                height: 400,
            });
            this.$store.dispatch('about/show', {id: this.id}).then((response) => {
                this.setContent(this.content);
            });
        },
        methods: {
            back() {
                this.$router.back();
            },
            update(ruleForm) {
                let vthis = this;
                this.$refs[ruleForm].validate((validate) => {
                    if (!validate) {
                        return;
                    }
                    this.About.content = CKEDITOR.instances.content.getData();
                    this.$store.dispatch('about/update').then(res => {
                        vthis.$confirm('是否关闭页面?')
                            .then(_ => {
                                vthis.$router.back();
                            });
                    })
                        .catch(res => {
                            console.log(res);
                        });
                });
            },
            setContent(content) {
                CKEDITOR.instances.content.setData(content);
    },
    },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/about/About.vue